// @ts-nocheck
import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useAppSelector, useAppDispatch } from "../hooks/useRedux";
import { useNavigate } from "react-router-dom";
import PostItem from "../components/PostItem";
import UserListItem from "../components/UserListItem";
import PostListLoader from "../components/PostListLoader";
import UserListLoader from "../components/UserListLoader";
import { themes } from "../Utils/Colors";
import { SEARCHICON } from "../assets/Icons";
import {
  searchPostsAndUsers,
  likePost,
  clearSearchResults,
} from "../store/postsSlice";
import { BASE_URL } from "../Constants/BaseUrl";

const SearchScreen = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [keyword, setKeyword] = useState("");
  const [playing, setPlaying] = useState(null);
  const [activeTab, setActiveTab] = useState("Posts");
  const [searchInitiated, setSearchInitiated] = useState(false);
  const [sports, setSports] = useState([]);

  const user = useAppSelector((state) => state?.user || {});
  const { searchResults = { posts: [], users: [] }, searchLoading = false } =
    useAppSelector((state) => state?.posts || {});

  const getSports = () => {
    axios
      .get(`${BASE_URL}sports/all`, {
        headers: { Accept: "application/json" },
      })
      .then((response) => setSports(response.data.data))
      .catch((error) => console.log("Error fetching sports:", error));
  };

  useEffect(() => {
    getSports();
  }, []);

  const handleSearch = () => {
    if (keyword.trim()) {
      dispatch(searchPostsAndUsers(keyword.trim()));
      setSearchInitiated(true);
      document.activeElement.blur();
    }
  };

  useEffect(() => {
    return () => {
      dispatch(clearSearchResults());
      setKeyword("");
      setSearchInitiated(false);
      setActiveTab("Posts");
      setPlaying(null);
    };
  }, []);

  const toggleLike = (id) => {
    dispatch(likePost(id));
  };

  const getSportsById = (id) => {
    const sport = sports.find((s) => s.id === id);
    return sport ? sport.sport_name : null;
  };

  const renderPost = ({ item }) => {
    return (
      <PostItem
        item={item}
        onToggleLike={toggleLike}
        playing={playing}
        setPlaying={setPlaying}
        fromSearchScreen={true}
      />
    );
  };

  const renderUser = ({ item }) => {
    if (item.role === "admin") return null;
    const details =
      item.role === "coach"
        ? item.coach_details
        : item.role === "student-athlete"
        ? item.athlete_details
        : null;
    if (!details) return null;
    return (
      <UserListItem item={item} sport_name={getSportsById(details.sport_id)} />
    );
  };

  const hasResults =
    searchResults.posts.length > 0 || searchResults.users.length > 0;

  return (
    <div className="min-h-screen bg-black flex justify-center">
      <div className="w-full max-w-2xl p-4 flex flex-col h-full">
        <div className="p-4">
          <div className="flex items-center rounded-md border border-gray-600 bg-white">
            <input
              autoFocus
              className="flex-1 bg-transparent text-black px-3 py-0 focus:outline-none"
              placeholder="Search posts or users..."
              placeholderTextColor="#D9D9D9"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              onKeyPress={(e) => e.key === "Enter" && handleSearch()}
            />
            <button onClick={handleSearch} className="p-3">
              <img src={SEARCHICON} alt="Search" className="w-4 h-4" />
            </button>
          </div>
        </div>

        {searchInitiated && hasResults && (
          <div className="flex justify-around border-b border-gray-700 py-3">
            {["Posts", "Users"].map((tab) => (
              <button
                key={tab}
                className={`pb-2 text-white ${
                  activeTab === tab ? "border-b-2 border-red-600" : ""
                }`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </div>
        )}

        {searchLoading ? (
          <div>
            {activeTab === "Posts" ? <PostListLoader /> : <UserListLoader />}
          </div>
        ) : !hasResults && searchInitiated ? (
          <div className="flex justify-center mt-5">
            <span className="text-white text-lg">No data found.</span>
          </div>
        ) : (
          <div className="flex-1 overflow-auto pb-24">
            {(activeTab === "Posts"
              ? searchResults.posts
              : searchResults.users
            ).map((item, index) => (
              <div
                key={activeTab === "Posts" ? item.post_id : item.id || index}
              >
                {activeTab === "Posts"
                  ? renderPost({ item })
                  : renderUser({ item })}
              </div>
            ))}
            {(activeTab === "Posts" ? searchResults.posts : searchResults.users)
              .length === 0 && (
              <div className="flex justify-center mt-5">
                <span className="text-white text-lg">
                  No {activeTab.toLowerCase()} found.
                </span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchScreen;
